export { LiveSearchSelectComponent } from './live-search-select.component';
export { LiveSearchSelectModule } from './live-search-select.module';



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/live-search-select/index.ts